import { PropTypes } from 'prop-types';
import renderTintColor from '../TintColor';
import styles from './style.m.less';

const NO_STYLE = {};

LoadingIndicator.propTypes = {
    small: PropTypes.bool,
    useTint: PropTypes.bool,
};

const BIG_SIZE = '40px';

export default function LoadingIndicator({ useTint = false, small = true }) {
    const sizeStyle = small ? {} : { height: BIG_SIZE, width: BIG_SIZE };
    const style = useTint ? { backgroundColor: renderTintColor() } : NO_STYLE;
    return (
        <div className={styles.loading_indicator}>
            <div className={styles.inner}>
                <div className={styles.ball_1} style={{ ...style, ...sizeStyle }} />
                <div className={styles.ball_2} style={{ ...style, ...sizeStyle }} />
            </div>
        </div>
    );
}
